import React, { ReactElement, useEffect, useState } from 'react';

import { classNames } from '@philips-emr/tws-utils';

import { useRouterContext } from '../with-router-context/with-router-context';

interface InlineImageProps {
  className?: string;
  src: string;
}

function isSVGURL(src: string): boolean {
  return src.endsWith('.svg');
}

function InlineImage(props: InlineImageProps): ReactElement | null {
  const { className, src } = props;
  const [href, setTarget] = useRouterContext(src);
  const [content, setContent] = useState<string | null>(null);

  const wrapperClassname = classNames({
    'c-inline-image': true,
    [`${className}`]: Boolean(className),
  });

  useEffect(() => {
    if (isSVGURL(href)) {
      fetch(href)
        .then((response) => response.text())
        .then((text) => setContent(text));
    } else {
      setContent(null);
    }
  }, [href]);

  useEffect(() => {
    setTarget(src);
  }, [src]);

  if (!isSVGURL(href)) {
    return (
      <div className={wrapperClassname}>
        <img src={href} />
      </div>
    );
  }

  if (!content) {
    return null;
  }

  return (
    <div className={wrapperClassname} dangerouslySetInnerHTML={{ __html: content }} />
  );
}

export default InlineImage;
